const extractLangAndCountry = (string) => {
  return {
    lang: string.split("-")[0],
    country: string.split("-")[1],
  }
}

module.exports = {
  extractLangAndCountry
}